import { useEffect } from 'react';

/**
 * Updates favicon links with cache busting query parameter
 * This ensures browsers fetch fresh favicons after deployment
 */
export default function FaviconUpdater() {
  useEffect(() => {
    const buildNumber = process.env.REACT_APP_BUILD_NUMBER || Date.now();
    const publicUrl = process.env.PUBLIC_URL || '';

    // Update favicon links
    const updateFavicon = (rel, href, sizes = null) => {
      // Remove existing link if present
      const existingLink = document.querySelector(`link[rel="${rel}"]${sizes ? `[sizes="${sizes}"]` : ''}`);
      if (existingLink) {
        existingLink.remove();
      }

      // Create new link with cache busting
      const link = document.createElement('link');
      link.rel = rel;
      link.href = `${publicUrl}${href}?v=${buildNumber}`;
      if (sizes) {
        link.sizes = sizes;
      }
      if (href.includes('.ico')) {
        link.type = 'image/x-icon';
      } else if (href.includes('.png')) {
        link.type = 'image/png';
      }
      document.head.appendChild(link);
    };

    // Update all favicon variants
    updateFavicon('icon', '/favicon.ico');
    updateFavicon('icon', '/favicon-32x32.png', '32x32');
    updateFavicon('icon', '/favicon-16x16.png', '16x16');
    updateFavicon('apple-touch-icon', '/apple-touch-icon.png');

    // Also update the shortcut icon (for older browsers)
    updateFavicon('shortcut icon', '/favicon.ico');
  }, []);

  return null;
}
